import { memo, useMemo } from 'react'

import { StoreOfferProduct } from '@common'
import cx from 'classnames'

import { useIsLoggedIn } from '@/features/common/useIsLoggedIn'
import { STORE_BG, gameNames } from '@/features/storefronts/_storeBase/constants'
import { useGameSlug } from '@/features/storefronts/game-provider'
import { useBreakpoints } from '@/utils/useBreakpoints'

import { CardBundle } from '../card/CardBundle'
import { StoreTypography } from '../typography/StoreTypography'

import storeStyles from '../storefronts.module.scss'
import styles from './bundles.module.scss'

export const Bundles = memo(({ bundles }: { bundles: StoreOfferProduct[] }) => {
  const gameSlug = useGameSlug()
  const from = useBreakpoints().from
  const isDesktop = from('tablet')
  const loggedIn = useIsLoggedIn()

  const useLoggedInText = useMemo(() => {
    return bundles.length === 0
      ? 'No Store Specials currently available.'
      : `These offers are only available in the ${gameNames[gameSlug]} Store. Enjoy!`
  }, [bundles.length, gameSlug])

  const specialOffersText = loggedIn ? useLoggedInText : 'Log in to see Store Specials.'

  return (
    <div
      className={cx(
        styles.bundles,
        styles[gameSlug],
        storeStyles[gameSlug],
        storeStyles.topOverlap,
        storeStyles.bottomOverlap,
      )}
      style={{ backgroundImage: STORE_BG(gameSlug) }}
    >
      <div id="storespecials" className={styles.specialsHeading}>
        <div className={styles.title}>
          <StoreTypography tag="h1" textSize={isDesktop ? 'xl' : 'lg'} style="outlined">
            Store Specials
          </StoreTypography>
        </div>
        <StoreTypography
          tag="p"
          style="plain"
          textSize={isDesktop ? 'md' : 'body'}
          overrideFont="supercellText"
          lineHeight="normal"
        >
          {specialOffersText}
        </StoreTypography>
      </div>
      <div className={styles.bundlesContainer}>
        {bundles.map((bundle, index) => (
          <CardBundle key={index} game={gameSlug} bundle={bundle} />
        ))}
      </div>
    </div>
  )
})

Bundles.displayName = 'Bundles'
